/* RETTERBOX cart-drawer.js — self-contained rb-drawer controller.
 * Owns: open/close, line-item render from /cart.js, qty stepper, remove,
 * shipping progress, savings, totals. Replaces Dawn's <cart-drawer> mechanics.
 */
(function () {
  'use strict';

  // ── Shopify money formatter ────────────────────────────────────────
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var fmt = format || (window.Shopify && window.Shopify.moneyFormat) || '€{{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(n, d) { return (n === undefined || n === null) ? d : n; }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, '.');
      decimal = defaultTo(decimal, ',');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }
    var match = fmt.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  var drawer = function () { return document.getElementById('rb-cart-drawer'); };
  var backdrop = function () { return document.querySelector('[data-cart-backdrop]'); };

  // Lock background scroll WITHOUT toggling body overflow. On this theme the page
  // scrolls on <body> (html has `overflow-x: clip`), so `body { overflow: hidden }`
  // moves the scroll onto <html> and breaks the position:sticky header + category
  // sidebar — they jump to their scrolled-away position and appear to vanish.
  // Instead we block wheel/touch scrolling outside the drawer, which keeps the
  // scroll container (and the sticky chrome) intact. Scrolling inside the drawer
  // still works (its body has overscroll-behavior: contain to stop chaining).
  var scrollBlocker = null;
  function lockScroll() {
    if (scrollBlocker) return;
    scrollBlocker = function (e) {
      var d = drawer();
      if (d && d.contains(e.target)) return; // allow scrolling inside the drawer
      e.preventDefault();
    };
    window.addEventListener('wheel', scrollBlocker, { passive: false });
    window.addEventListener('touchmove', scrollBlocker, { passive: false });
  }
  function unlockScroll() {
    if (!scrollBlocker) return;
    window.removeEventListener('wheel', scrollBlocker, { passive: false });
    window.removeEventListener('touchmove', scrollBlocker, { passive: false });
    scrollBlocker = null;
  }

  // ── Open / close ───────────────────────────────────────────────────
  function openCart() {
    var d = drawer(), b = backdrop();
    if (!d) return;
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    if (b) b.classList.add('open');
    lockScroll();
    if (window.RB_syncCart) window.RB_syncCart();
  }
  function closeCart() {
    var d = drawer(), b = backdrop();
    if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
    if (b) b.classList.remove('open');
    unlockScroll();
  }
  window.RB_openCart = openCart;
  window.RB_closeCart = closeCart;

  // ── Render line items + totals from a cart JSON object ─────────────
  var SVG_BOX = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>';
  var SVG_MINUS = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  var SVG_PLUS = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  var SVG_TRASH = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>';
  var SVG_X = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

  function isDepositLine(item) {
    var cfg = window.RB_PFAND || {};
    if (item.properties && item.properties._system_deposit === 'true') return true;
    return (cfg.systemVariantIds || []).indexOf(item.variant_id) >= 0;
  }

  // Robust Shopify CDN resize via query params (works for any filename).
  function sizedImg(url, px) {
    if (!url) return url;
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    return url + sep + 'width=' + px + '&height=' + px + '&crop=center';
  }

  var SVG_DEPOSIT = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M9 3h6l-.6 3H9.6L9 3z"/><path d="M8.6 6h6.8l-.7 13a2 2 0 0 1-2 1.9h-1.4a2 2 0 0 1-2-1.9L8.6 6z"/><path d="M9 13h6"/></svg>';

  // Read-only Pfand sub-line: visually subordinate to the product it belongs to
  // (indented + connector, parent product thumbnail). No stepper / no remove —
  // pfand.js keeps it in sync. `parent` is the product line it hangs under.
  function depositLineHTML(item, parent) {
    var thumb = item.image
      ? '<img src="' + sizedImg(item.image, 96) + '" alt="" width="30" height="30">'
      : SVG_DEPOSIT;
    return '<div class="rb-line rb-line--deposit" data-line-key="' + item.key + '" data-variant-id="' + item.variant_id + '" aria-label="Pfand">'
      + '<div class="rb-line__depicon">' + thumb + '</div>'
      + '<div class="rb-line__depbody">'
      + '<div class="rb-line__depname">zzgl. Einwegpfand</div>'
      + '<div class="rb-line__depmeta">' + item.quantity + ' × ' + formatMoney(item.final_price) + '</div>'
      + '</div>'
      + '<div class="rb-line__depprice">' + formatMoney(item.final_line_price) + '</div>'
      + '</div>';
  }

  // Order lines so each aggregated deposit line renders right after the FIRST
  // product that requires that deposit type (so it visibly belongs to the article).
  function orderedLinesHTML(cart) {
    var cfg = window.RB_PFAND || {};
    var map = cfg.map || {}, cartMap = cfg.cart || {};
    var depVarToProductPfand = {};                 // depositVariantId -> pfand title
    Object.keys(map).forEach(function (t) { depVarToProductPfand[map[t].variantId] = t; });

    function productPfand(it) {
      return (it.properties && it.properties._pfand) || cartMap[it.product_id] || null;
    }

    var deposits = {};                             // depositVariantId -> deposit line
    cart.items.forEach(function (it) { if (isDepositLine(it)) deposits[it.variant_id] = it; });

    var html = '', placed = {};
    cart.items.forEach(function (it) {
      if (isDepositLine(it)) return;               // deposits are placed under their product
      html += lineHTML(it);
      var t = productPfand(it);
      if (t && map[t]) {
        var dv = map[t].variantId;
        if (deposits[dv] && !placed[dv]) { html += depositLineHTML(deposits[dv], it); placed[dv] = true; }
      }
    });
    // Any deposit line we couldn't attach (no matching product found) → render at end.
    Object.keys(deposits).forEach(function (dv) { if (!placed[dv]) html += depositLineHTML(deposits[dv], null); });
    return html;
  }

  function lineHTML(item) {
    if (isDepositLine(item)) return depositLineHTML(item);
    var img = item.image
      ? '<img src="' + sizedImg(item.image, 240) + '" alt="">'
      : SVG_BOX;
    var qty = item.quantity;
    var maxQ = parseInt((item.properties && item.properties._max_qty), 10);
    var atMax = maxQ > 0 && qty >= maxQ;
    var cmp = parseInt((item.properties && item.properties._cmp), 10);   // compare-at unit (cents)
    if (!(cmp > 0) && window.RB_CMP) cmp = parseInt(window.RB_CMP[item.variant_id], 10);   // initial-cart fallback
    var unit = item.final_price;
    var hasSale = cmp > 0 && cmp > unit;
    var pct = hasSale ? Math.round((1 - unit / cmp) * 100) : 0;

    // Overlapping pill stepper: minus becomes a trash at qty 1; "+" becomes "Max" at the cap.
    var minusBtn = '<button type="button" data-line-dec class="rb-line__step' + (qty > 1 ? '' : ' rb-line__step--rm') + '" aria-label="' + (qty > 1 ? 'Weniger' : 'Entfernen') + '">' + (qty > 1 ? SVG_MINUS : SVG_TRASH) + '</button>';
    var plusSlot = atMax
      ? '<span class="rb-line__max" aria-label="Maximale Menge erreicht">Max</span>'
      : '<button type="button" data-line-inc class="rb-line__step rb-line__step--add" aria-label="Mehr">' + SVG_PLUS + '</button>';

    return '<div class="rb-line" data-line-key="' + item.key + '" data-variant-id="' + item.variant_id + '" data-max-qty="' + ((item.properties && item.properties._max_qty) || '') + '">'
      + '<div class="rb-line__media">'
      + img
      + (hasSale ? '<span class="rb-line__sale">&minus;' + pct + '%</span>' : '')
      + '<div class="rb-line__stepper">' + minusBtn
      + '<span data-line-qty>' + qty + '</span>' + plusSlot + '</div>'
      + '</div>'
      + '<div class="rb-line__body">'
      + '<button type="button" class="rb-line__x" data-line-remove aria-label="Entfernen">' + SVG_X + '</button>'
      + '<div class="rb-line__name">' + item.product_title + '</div>'
      + (hasSale
        ? '<div class="rb-line__tag rb-line__tag--sale">Im Angebot</div>'
        : '<div class="rb-line__tag">' + (item.vendor || '') + '</div>')
      + '<div class="rb-line__prices">'
      + '<div class="rb-line__pcol">'
      + '<div class="rb-line__unitrow"><span class="rb-line__unit' + (hasSale ? ' rb-line__unit--sale' : '') + '">' + formatMoney(unit) + '</span>'
      + (hasSale ? '<span class="rb-line__strike">' + formatMoney(cmp) + '</span>' : '') + '</div>'
      + '<div class="rb-line__cap">Stückpreis</div>'
      + '</div>'
      + '<div class="rb-line__pcol rb-line__pcol--right">'
      + '<div class="rb-line__total">' + formatMoney(item.final_line_price) + '</div>'
      + '<div class="rb-line__cap">Gesamt</div>'
      + '</div>'
      + '</div>'
      + '</div>'
      + '</div>';
  }

  // ── Shipping economics — mirrors retterbox_app/features/cart/shipping.ts (AT/DE
  //    ladder). Amounts in cents. min order 20 €, 0→6,95 €, 29→4,95 €, ≥45 → gratis.
  var SHIP = { min: 2000, free: 4500, tiers: [{ from: 0, price: 695 }, { from: 2900, price: 495 }, { from: 4500, price: 0 }] };
  function shipEco(sub) {
    var appl = SHIP.tiers[0];
    SHIP.tiers.forEach(function (t) { if (t.from <= sub) appl = t; });
    var freeReached = sub >= SHIP.free, minReached = sub >= SHIP.min;
    return {
      shipping: appl.price, freeReached: freeReached, minReached: minReached,
      minRemaining: Math.max(0, SHIP.min - sub), freeRemaining: Math.max(0, SHIP.free - sub),
      goal: !minReached ? 'min' : (!freeReached ? 'free' : 'done'),
    };
  }
  // Bootstrap Icons — match the app's FreeShippingBar fallbacks (basket / check-circle-fill).
  var SVG_BASKET = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"><path d="M5.757 1.071a.5.5 0 0 1 .172.686L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1v4.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 13.5V9a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1.217L5.07 1.243a.5.5 0 0 1 .686-.172zM2 9v4.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V9zM1 7v1h14V7zm3 3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 4 10m2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 6 10m2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 8 10m2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5m2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5"/></svg>';
  var SVG_CHECK = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/></svg>';
  // Build the app-style tiered shipping bar (segments + per-band labels + headline).
  function shipBar(sub) {
    var e = shipEco(sub);
    var tail = Math.max(Math.round(SHIP.free * 0.18), 600);
    var scaleMax = Math.max(SHIP.free + tail, sub, 1);
    var raw = [0, SHIP.min].concat(SHIP.tiers.map(function (t) { return t.from; })).concat([SHIP.free, scaleMax]);
    var bounds = raw.filter(function (v) { return v >= 0 && v <= scaleMax; });
    bounds = bounds.filter(function (v, i) { return bounds.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
    var progress = e.freeReached ? scaleMax : Math.min(sub, scaleMax);
    var seg = '', lab = '';
    for (var i = 0; i < bounds.length - 1; i++) {
      var s = bounds[i], en = bounds[i + 1], span = (en - s) || 1;
      var ratio = Math.min(1, Math.max(0, (progress - s) / span));
      var belowMin = SHIP.min > 0 && en <= SHIP.min, isFree = s >= SHIP.free;
      var priceAt = 0; SHIP.tiers.forEach(function (t) { if (t.from <= s) priceAt = t.price; });
      var label = belowMin ? ('ab ' + formatMoney(SHIP.min)) : (isFree || priceAt === 0 ? 'Gratis' : formatMoney(priceAt));
      var active = sub >= s && sub < en;
      seg += '<div class="rb-ship__seg" style="flex:' + span + '"><div class="rb-ship__fill" style="width:' + (ratio * 100) + '%"></div></div>';
      lab += '<div class="rb-ship__lab' + (active ? ' rb-ship__lab--active' : '') + '" style="flex:' + span + '">' + label + '</div>';
    }
    var head, subl = '';
    if (e.freeReached) { head = 'Gratisversand erreicht 🎉'; }
    else if (e.goal === 'min') { head = 'Nur noch <b>' + formatMoney(e.minRemaining) + '</b> bis zum Mindestbestellwert'; subl = 'Gratisversand ab ' + formatMoney(SHIP.free); }
    else if (e.goal === 'free') { head = 'Nur noch <b>' + formatMoney(e.freeRemaining) + '</b> bis zum Gratisversand'; }
    else { head = 'Mindestbestellwert erreicht'; }
    return { icon: e.freeReached ? SVG_CHECK : SVG_BASKET, head: head, sub: subl, track: seg, labels: lab, eco: e };
  }

  function renderCart(cart) {
    var d = drawer();
    if (!d || !cart) return;
    var freeShip = parseInt(d.dataset.freeShip, 10) || 4900;
    var lines = d.querySelector('[data-cart-lines]');
    var empty = cart.item_count === 0;

    // Line items
    if (lines) {
      if (empty) {
        lines.innerHTML = '<div class="rb-drawer__empty" data-cart-empty>'
          + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>'
          + '<p>Dein Warenkorb ist noch leer.<br>Zeit zu retten!</p></div>';
      } else {
        // Each deposit renders directly after the product it belongs to.
        lines.innerHTML = orderedLinesHTML(cart);
      }
    }

    // Count badge
    d.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = empty;
    });

    // Product subtotal excludes the system deposit lines (shown as their own Pfand row).
    var productSub = 0, depositTotal = 0, count = 0;
    cart.items.forEach(function (it) {
      if (isDepositLine(it)) { depositTotal += it.final_line_price; }
      else { productSub += it.final_line_price; count += it.quantity; }
    });
    var bar = shipBar(productSub);
    var eco = bar.eco;
    var grand = productSub + depositTotal + bar.eco.shipping;

    function setText(sel, txt) { var el = d.querySelector(sel); if (el) el.textContent = txt; }
    function setHTML(sel, html) { var el = d.querySelector(sel); if (el) el.innerHTML = html; }

    // Shipping bar (app-style tiered track)
    var shipWrap = d.querySelector('[data-ship-wrap]');
    if (shipWrap) {
      shipWrap.hidden = empty;
      setHTML('[data-ship-icon]', bar.icon);
      setHTML('[data-ship-headline]', bar.head);
      var sub = d.querySelector('[data-ship-sub]');
      if (sub) { sub.innerHTML = bar.sub; sub.hidden = !bar.sub; }
      setHTML('[data-ship-track]', bar.track);
      setHTML('[data-ship-labels]', bar.labels);
    }

    // Footer summary (app-style: Produkte / Pfand / Versand / Gesamtsumme)
    var foot = d.querySelector('[data-cart-foot]');
    if (foot) foot.hidden = empty;
    setText('[data-sum-count]', 'Produkte (' + count + ')');
    setText('[data-cart-subtotal]', formatMoney(productSub));
    var depRow = d.querySelector('[data-sum-deposit-row]');
    if (depRow) depRow.hidden = depositTotal <= 0;
    setText('[data-sum-deposit]', formatMoney(depositTotal));
    var shipEl = d.querySelector('[data-cart-shipping]');
    if (shipEl) {
      shipEl.textContent = eco.shipping === 0 ? 'Gratis' : formatMoney(eco.shipping);
      shipEl.classList.toggle('rb-drawer__free', eco.shipping === 0);
    }
    setText('[data-cart-total]', formatMoney(grand));

    // Checkout CTA — blocked below the minimum order value (matches the app gate).
    var cta = d.querySelector('[data-cart-checkout]');
    if (cta) {
      var blocked = !eco.minReached;
      cta.classList.toggle('rb-btn--disabled', blocked);
      cta.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      cta.dataset.blocked = blocked ? '1' : '';
      var lbl = cta.querySelector('[data-cta-label]'), amt = cta.querySelector('[data-cta-amount]');
      if (blocked) {
        if (lbl) lbl.textContent = 'Noch ' + formatMoney(eco.minRemaining) + ' bis zur Bestellung';
        if (amt) amt.textContent = '';
      } else {
        if (lbl) lbl.textContent = 'Sicher zur Kasse';
        if (amt) amt.textContent = formatMoney(grand);
      }
    }
  }

  document.addEventListener('cart:updated', function (e) { renderCart(e.detail); });

  // ── Global click delegation ────────────────────────────────────────
  document.addEventListener('click', function (e) {
    // Open via any cart toggle (header button, mobile nav)
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openCart(); return; }
    // Close
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-backdrop]')) { closeCart(); return; }
    // Block checkout below the minimum order value.
    var co = e.target.closest('[data-cart-checkout]');
    if (co && co.dataset.blocked === '1') { e.preventDefault(); return; }

    // Line stepper / remove inside the drawer
    var line = e.target.closest('.rb-line');
    if (!line) return;
    var key = line.dataset.lineKey;
    if (!key) return;

    if (e.target.closest('[data-line-inc]')) { changeLine(key, deltaQty(line, 1)); }
    else if (e.target.closest('[data-line-dec]')) { changeLine(key, deltaQty(line, -1)); }
    else if (e.target.closest('[data-line-remove]')) { changeLine(key, 0); }
  });

  function deltaQty(line, delta) {
    var span = line.querySelector('[data-line-qty]');
    var cur = span ? parseInt(span.textContent, 10) || 0 : 0;
    var next = Math.max(0, cur + delta);
    var max = parseInt(line.dataset.maxQty, 10);   // soft cap at custom.max_order_qty
    if (delta > 0 && max > 0 && next > max) next = max;
    return next;
  }

  var busy = false;
  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart })); })
      .catch(function (err) { console.error('RETTERBOX: cart change failed', err); })
      .finally(function () { busy = false; });
  }

  // ESC closes
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  // Relay cart:open → openCart
  document.addEventListener('cart:open', openCart);

})();
